import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSplideModule } from 'ngx-splide';
import { sliderOptions } from '@app/domain/properties/slider.properties';

@Component({
  selector: 'bingo-how-it-works-darts',
  imports: [NgxSplideModule],
  templateUrl: './how-it-works-darts.component.html',
  styleUrl: './how-it-works-darts.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowItWorksDartsComponent {
  protected readonly sliderOptions = sliderOptions;
}
